import { Libraries } from '@react-google-maps/api';
import { Option } from '@common/types';

export const ALL_OPTION = {
  value: '',
  label: 'All',
} as const;

export const createAllOption = (label: string = 'All') =>
  ({
    value: '',
    label,
  }) as const;

export const selectBooleanOptions: Option[] = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export const ROOT_ORGANIZATION_ID = '00000000-0000-4000-8000-000000000000';

export const GOOGLE_LIBRARIES: Libraries = ['places'];

export const MAXIMUM_TEXT_AREA_LENGTH = 5_000;
export const MAXIMUM_TEXT_LENGTH = 5_000;
export const MAXIMUM_STRING_LENGTH = 100;
export const MAXIMUM_COMMENT_LENGTH = 500;
export const MAXIMUM_ARRAY_LENGTH = 20;
export const MAXIMUM_NUMBER_OF_USER_ROLES = 20;
export const PATIENT_TASK_LOCK_PERIOD = 30_000;
export const PATIENT_TASK_LOCK_PERIOD_VARIATION = 10_000;
export const HEARTBEAT_PERIOD = 60_000;
export const HEARTBEAT_PERIOD_VARIATION = 30_000;
export const MAX_INTEGER = 32_768;
export const TASK_MAX_RECORDED_MINUTES = 1_440;
export const MAX_MULTISELECT_OPTIONS = 20;

export const EXPECTED_DAILY_USER_MINUTES = 400;

export const FAILED_OUTREACH_ATTEMPTS_UNTIL_COMPLETION = 3;

export const MAX_PINNED_COLUMNS = 3;
